import { render, staticRenderFns } from "./RoomItem.vue?vue&type=template&id=03c6cd6f&"
import script from "./RoomItem.vue?vue&type=script&lang=ts&"
export * from "./RoomItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports